export const common = {
  // Navbar
  courseFlow: 'Course Flow',
  curriculum: 'Curriculum',
  pricing: 'Pricing',
  wordPool: 'Word Pool',
  levelCheck: 'Level Check',
  register: 'Register',
  myPage: 'My Page',
  signOut: 'Sign Out',
  admin: 'Admin',
  orgSchedule: 'Org Schedule',
  
  // Footer
  quickLinks: 'Quick Links',
  home: 'Home',
  contact: 'Contact',
  contactForm: 'Contact Form',
  allRightsReserved: 'All rights reserved.',
  websiteBuilder: 'Website Builder',
  
  // Common
  submit: 'Submit',
  submitting: 'Submitting...',
  required: 'Required fields',
  optional: 'Optional',
  cancel: 'Cancel',
  close: 'Close',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  search: 'Search',
  filter: 'Filter',
  loading: 'Loading...',
  error: 'An error occurred',
  success: 'Success',
  
  // Brand
  brandName: 'EachTeach',
  brandTagline: 'Quality 1-on-1 language exchange service for serious learners',
  additionalLesson: {
    title: 'Additional Lesson Application',
    subtitle: 'Apply for specialized lessons in your area of interest',
    backToCourseFlow: 'Back to Course Flow',
    specializedFields: '8 Specialized Fields',
    chooseYourField: 'Choose Your Field',
    fieldDescription: 'Each course is designed for specific workplace scenarios and communication needs',
    lessons: 'Lessons',
    courses: {
      daily: {
        name: 'Daily Life & Casual Communication',
        description: 'Learn versatile expressions used in daily life and relationships, including casual conversation, slang, idioms, and proverbs.'
      },
      customerService: {
        name: 'Customer Service & Hospitality Communication',
        description: 'Learn expressions needed in customer service settings such as restaurants and cafes, including taking orders, explanations, recommendations, and handling complaints.'
      },
      kitchen: {
        name: 'Kitchen & Culinary Communication',
        description: 'Learn instruction expressions, ingredient and cooking terminology, safety checks, and team coordination used in kitchen and cooking environments.'
      },
      retail: {
        name: 'Sales & Cashier Communication',
        description: 'Learn product explanations, size and inventory checks, payment processing, and return/exchange handling for retail stores and shops.'
      },
      hotel: {
        name: 'Hotel & Front Desk Operations',
        description: 'Learn check-in/check-out procedures, facility guidance, inquiries, phone handling, and complaint resolution for hotels and accommodation facilities.'
      },
      cleaning: {
        name: 'Cleaning & Back Office Operations',
        description: 'Learn instruction comprehension, confirmation expressions, checklists, and safety-related expressions needed for cleaning and back office work.'
      },
      resort: {
        name: 'Resort & Seasonal Work',
        description: 'Learn team communication and customer service expressions in multinational environments, assuming tourist destinations and short-term employment.'
      },
      workplace: {
        name: 'Workplace & Advanced Communication',
        description: 'Learn more advanced business communication including emails, reports, coordination, requests, and trouble sharing in post-employment workplace environments.'
      }
    },
    form: {
      title: 'Application Form',
      subtitle: 'Fill out the form below to apply for your chosen field',
      name: 'Name',
      email: 'Email',
      language: 'Learning Language',
      firstChoice: 'First Choice',
      secondChoice: 'Second Choice',
      thirdChoice: 'Third Choice',
      goals: 'Learning Goals & Requests',
      required: 'Required',
      optional: 'Optional',
      selectLanguage: 'Select a language',
      japanese: 'Japanese',
      korean: 'Korean',
      english: 'English',
      selectFirstChoice: 'Select your first choice',
      selectSecondChoice: 'Select your second choice (optional)',
      selectThirdChoice: 'Select your third choice (optional)',
      goalsPlaceholder: 'Please describe your learning goals and any specific requests (optional)',
      characters: 'characters',
      cancel: 'Cancel',
      submit: 'Submit Application',
      submitting: 'Submitting...',
      successMessage: 'Your application has been submitted successfully.',
      errorMessage: 'Please fill in all required fields.',
      submitError: 'Submission failed. Please try again.'
    },
    info: {
      title: 'About Additional Lessons:',
      point1: 'Available after completing Lessons A-C',
      point2: 'Specialized lessons tailored to your field of interest',
      point3: 'We will contact you within 2-3 business days',
      point4: 'You can select up to 3 preferred fields'
    }
  }
};
